import * as React from 'react';

interface IProps {
  label: any,
  value: any,
  placeholder?: string,
  icon?: string,
  dataField: string,

  changeCallback: (e: React.FormEvent<HTMLTextAreaElement>, field: string) => void
}

export const AreaInput: React.SFC<IProps> = props => {
  return (
      <div className="field">
        <label className="label">{props.label}</label>
        <div className={(props.icon) ? "control has-icons-left" : "control"}>
          <textarea
            onChange={(event: React.FormEvent<HTMLTextAreaElement>) => props.changeCallback(event, props.dataField)} // tslint:disable-line
            className="textarea"
            placeholder={(props.placeholder) ? props.placeholder : "type here"}
            required={true}
            value={props.value}
            />
          {
            (props.icon)
            ? (<span className="icon is-small is-left"><i className={"fa " + props.icon} /></span>)
            : ''
            }

        </div>
      </div>
  )
};



// WEBPACK FOOTER //
// ./src/Containers/generators/EditGenerator/input/AreaInput.tsx